import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import auth from './auth'

Vue.use(VueAxios, axios)
// axios实例
const axiosInstance = axios.create({
  withCredentials: true
})

Vue.prototype.$axios = axiosInstance

axiosInstance.interceptors.request.use(
  (config) => {
    const token = auth.getToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token
    }
    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && (error.response.status === 403 || error.response.status === 401)) {
      // 清除本地 Token
      auth.clearToken()
      // 跳转登录页，保留当前路径作为 redirect 参数
      const currentPath = window.location.pathname
      // 排除登录页本身，避免 redirect 循环
      if (currentPath !== '/login') {
        window.location.href = '/login?redirect=' + encodeURIComponent(currentPath)
      } else {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

// 将 auth 工具挂载到 Vue 原型，方便组件使用
Vue.prototype.$auth = auth

// 导出 axios 实例，供非组件模块使用
export default axiosInstance



// WEBPACK FOOTER //
// ./src/utils/axios.js